module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Education centre-e6475bdb70631e8aa32d77e9aaf36015.png";